import {handleActions} from 'redux-actions';
import {createReducer} from "../baseReducer/baseReducer";


// ------------------------------------
// Constants
// ------------------------------------

export const { reducers, initialState, actions } = createReducer(
    "usuarios-serie",
    "usuarios-serie",
    "SeriesForm",
    "/usuarios", // Redirigir a Usuarios
);

export default handleActions(reducers, initialState);